/**
 * This module provides the form handler for the Wallbox-Settings of a Storage device.
 *
 * It uses a work in progress implementation of the Formik form handler.
 */

import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { AuthFieldSet, CommonFieldSet, HysteresisFieldSet } from 'src/Libs/wallboxes/components/settings/tiles'
import WallboxSettingsFormGridContainer from './WallboxSettingsFormGridContainer'
import WallboxSettingsFormGridItem from './WallboxSettingsFormGridItem'

interface Props {
  model: WallboxConfigurationModel
  hasWritingAccess: boolean
}

/**
 * Configured form component for a Wallbox of type Bidi (@see https://docs.e3dc.com/x/zgrIAw)
 */
const WallboxSettingsBidiForm: React.FC<Props> = ({ model, hasWritingAccess }) => {
  return (
    <SettingsFormContainer model={model}>
      <WallboxSettingsFormGridContainer>
        <WallboxSettingsFormGridItem>
          <CommonFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>

        <WallboxSettingsFormGridItem>
          <HysteresisFieldSet model={model} displayCapacity displayBidiMode disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>

        <WallboxSettingsFormGridItem>
          <AuthFieldSet model={model} hasKeyLockMode={false} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>
      </WallboxSettingsFormGridContainer>
    </SettingsFormContainer>
  )
}

export default WallboxSettingsBidiForm
